export type SendMessageAttachment =
    { kind: 'file'; file: Blob; fileName: string } | { kind: 'quick-reply-media'; mediaId: number };

export interface SendMessageParams {
    text: string;
    attachment?: SendMessageAttachment | null;
    clientRequestId?: string;
}

export type SendMessageRequest =
    | { multipart: false; body: { text: string; clientRequestId?: string } }
    | { multipart: true; body: FormData };

function buildMultipartBody(
    text: string,
    attachment: SendMessageAttachment,
    clientRequestId: string | undefined
): FormData {
    const form = new FormData();
    if (text) form.append('text', text);
    if (attachment.kind === 'file') {
        form.append('attachment', attachment.file, attachment.fileName);
    } else {
        form.append('quickReplyMediaId', String(attachment.mediaId));
    }
    if (clientRequestId) form.append('clientRequestId', clientRequestId);
    return form;
}

// One attachment source per message: the union makes a file and quick-reply media exclusive.
export function buildSendMessageRequest({
    text,
    attachment,
    clientRequestId
}: SendMessageParams): SendMessageRequest {
    const trimmed = text.trim();
    if (attachment) {
        return {
            multipart: true,
            body: buildMultipartBody(trimmed, attachment, clientRequestId)
        };
    }
    if (!trimmed) throw new Error('Cannot send an empty message.');
    const body = clientRequestId ? { text: trimmed, clientRequestId } : { text: trimmed };
    return { multipart: false, body };
}
